export const MUTABLE_CELL = Symbol('MUTABLE_CELL');
